<template>
  <div class="login-box">
    <el-form :model="form" :rules="rules" ref="ruleForm" class="el_form">
      <el-form-item prop="mobile">
        <el-input v-model="form.mobile" type="number" placeholder="请输入11位手机号"></el-input>
      </el-form-item>
      <el-form-item prop="code">
        <el-input v-model="form.code" type="number" placeholder="验证码">
          <el-button slot="append" size="mini" @click="verCodeClick">{{clickVerCode ? verSecond + 's' : "获取验证码"}}</el-button>
        </el-input>
      </el-form-item>
      <el-form-item class="el_item">
        <el-button type="primary" class="elBtn" @click="subBtn">登陆</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        mobile: "",
        code: "",
      },
      verSecond: 60,
      clickVerCode: false,
      timer: null, // 初始化定时器变量名为null
      rules: {
        mobile: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.clearCurTimer();
  },
  methods: {
    // 获取验证码
    verCodeClick() {
      if (!this.form.mobile) {
        this.$message.error("请输入手机号");
        return;
      }
      if (
        /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/.test(
          this.form.mobile
        ) == false
      ) {
        this.$message.error("手机号格式错误");
        return;
      }
      let that = this;
      if (that.clickVerCode) {
        return;
      }
      this.$api
        .get("https://gm.zs.ollq.com:8868/BaBaLiuLiu/client/mobile", {
          params: {
            mobile: this.form.mobile,
          },
        })
        .then((res) => {
          that.clickVerCode = true;
          that.timer = setInterval(() => {
            // console.log('定时器开启')
            if (that.verSecond == 1) {
              that.clickVerCode = false;
              that.verSecond = 60;
              that.clearCurTimer();
            }
            that.verSecond -= 1;
          }, 1 * 1000);
        });
    },
    clearCurTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    // 登陆按钮
    subBtn() {
      this.$api
        .get("https://gm.zs.ollq.com:8868/BaBaLiuLiu/client/code", {
          params: {
            mobile: this.form.mobile,
            code: this.form.code,
          },
        })
        .then((res) => {
          console.log(res);
          let Data = res.data.Data;
          console.log(Data);
          Data.forEach((e) => {
            sessionStorage.mobile = e.mobile;
          });
          this.$router.push("/Container/home");
          // sessionStorage.mobile = this.form.mobile;
        })
        .catch((err) => {
          this.dialogVisible = true;
          this.mistake = err.data.ErrMsg;
        });
    },
  },
};
</script>

<style>
@import url(login.css);
</style>


// WEBPACK FOOTER //
// src/views/login/login.vue